export default __webpack_public_path__ + "static/media/ashe-deadlockgang.bd98b6cc.mp3";